/**
 * Lightweight markdown-to-HTML converter for server-controlled checklist content.
 * Supports: **bold**, [text](url) links, and \n line breaks.
 */
export default function renderSimpleMarkdown(text) {
  if (!text) return '';

  let html = text
    // Escape HTML entities
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // Bold: **text**
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    // Links: [text](url) — same-origin links use data-internal-link, external links open in new tab
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, (_, text, url) => {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const isInternal = url.startsWith('/') || (origin && url.startsWith(origin));
      if (isInternal) {
        // Strip origin to get the pathname for React Router
        const path = url.startsWith('/') ? url : url.replace(origin, '');
        return `<a href="${path}" data-internal-link="true" class="text-primaryColor underline">${text}</a>`;
      }
      return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-primaryColor underline">${text}</a>`;
    })
    // Newlines
    .replace(/\n/g, '<br />');

  return html;
}
